import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { cn } from "@util/helpers";

type AseanInsightsEntryProps = {
  /** This is the classname of the component. */
  className?: string;
};

/**
 * Asean Insight widget entry point component. Initially placed in article pages.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20615-30959&m=dev
 */
const AseanInsightsEntry = ({
  className,
}: AseanInsightsEntryProps): React.ReactElement => {
  const link = `${RouteFactory.keywordsAseanInsights}?ref=asean-intelligence-article-banner`;

  return (
    <div
      data-testid="asean-insights-entry-component"
      className={cn(
        "track-impression group relative rounded-lg border border-gray-175 bg-white px-6 pb-9 pt-8 text-center shadow-[0px_4px_32px_0px_rgba(0,0,0,0.05)]",
        "lg:pb-8",
        className
      )}
      data-section-name="asean intelligence report"
    >
      <div className="mx-auto w-[270px] max-w-full">
        <IconFactory
          type={IconTypeEnum.graphic}
          className="mx-auto mb-3 text-blue-175"
          x={64}
          y={64}
          size={64}
        />

        <h3 className="mb-3 font-lct text-7xl font-normal leading-120 tracking-0">
          Asean Intelligence
        </h3>

        <p className="mb-4 text-center font-lct text-lg font-normal leading-150 tracking-0">
          Get insights into businesses across South-east Asia
        </p>

        <ButtonFactory
          buttonType={ButtonType.Link}
          mask={ButtonType.Primary}
          text="Get the free report"
          link={link}
          className="w-full bg-blue-175 text-base leading-150 tracking-2 !text-white group-hover:bg-blue-300"
        />
      </div>

      <Link to={link} className="absolute inset-0" reloadDocument />
    </div>
  );
};

export default AseanInsightsEntry;
